exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._36tnovB_RJZt9YCHnVWu2t{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:1.14286rem}._1N80wVqAHNvvhcdMkcHTjJ{margin-bottom:1.14286rem}._3p-x49UiBBF_IrC7w7DhAn{font-size:1rem;line-height:1.6;letter-spacing:.07143rem;white-space:pre-line}._1ne4U_la5EyCHe8v07FRlv{padding:2.85714rem;text-align:center;color:#a4a4a4;font-size:1rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"header": "_36tnovB_RJZt9YCHnVWu2t",
	"section": "_1N80wVqAHNvvhcdMkcHTjJ",
	"sectionContent": "_3p-x49UiBBF_IrC7w7DhAn",
	"empty": "_1ne4U_la5EyCHe8v07FRlv"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/CoveredInClassRAv2/style.postcss
// module id = 1569
// module chunks = 0